/* global restVar */
import { useState, useRef } from '@wordpress/element';
import Bono from './Bono';
import Scanner from './Scanner';
import ScannerIcon from './ScannerIcon.svg';
import Spinner from '../../shared/components/Spinner';

export default function Bonos( { bonos, ticketValue, readedBonosState } ) {
	const [ possibleBonos, setPossibleBonos ] = bonos;
	const [ isScanning, setIsScanning ] = useState( false );
	const [ error, setError ] = useState( null );
	const [ isLoading, setIsLoading ] = useState( false );
	const [ readedBonos, setReadedBonos ] = readedBonosState;
	const manualCodeRef = useRef( null );
	const videoRef = useRef( null );

	// Verifica si el código recibido es válido.
	const checkCode = ( code ) => {
		return /^[0-9a-zA-Z]{10}$/.test( code );
	};

	// Verifica el código introducido manualmente.
	const manualBono = ( e ) => {
		e.preventDefault();
		const code = manualCodeRef.current.value.trim().toLowerCase();
		if ( ! checkCode( code ) ) {
			setError( 'El código debe tener 10 caracteres alfanuméricos' );
			return;
		}
		setError( null );
		getBonoFromServer( code );
	};

	// Comprobamos si el bono recibido está ya en la lista de bonos leídos.
	const checkDuplicateBono = ( bono ) => {
		return readedBonos.some(
			( readedBono ) => readedBono.codigo === bono.codigo
		);
	};

	// Restamos a ticketvalue el valor de los bonos ya leídos y válidos.
	const getTotalValue = () => {
		return readedBonos.reduce( ( acc, bono ) => {
			return 'valid' === bono.status ? acc - bono.value : acc;
		}, ticketValue );
	};

	// Obtenemos el bono del servidor.
	const getBonoFromServer = ( code ) => {
		setIsLoading( true );

		fetch( restVar.sciBonosComercioEndpoint, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-WP-Nonce': restVar.nonce,
			},
			body: JSON.stringify( { code, possibleBonos } ),
		} )
			.then( ( response ) => response.json() )
			.then( ( data ) => {
				// La respuesta del servidor es un array con dos elementos: El código del bono y los posibles bonos restantes.
				if ( ! checkDuplicateBono( data[ 0 ] ) ) {
					setReadedBonos( [ ...readedBonos, data[ 0 ] ] );
					setPossibleBonos( data[ 1 ] );
				}

				manualCodeRef.current.value = '';
			} )
			.catch( ( e ) => setError( `Error al obtener el bono: ${ e }` ) )
			.finally( () => setIsLoading( false ) );
	};

	return (
		<div className="sci-bcl-bonos">
			<h3>Bonos: </h3>
			<p style={ { 'margin-bottom': 0, 'margin-top': 0 } }>
				Escanea todos los bonos de esta compra.
			</p>
			<p style={ { 'margin-top': 0 } }>
				<strong>
					Recuerda validar el ticket después de escanear todos los
					bonos.
				</strong>
			</p>
			{ readedBonos.length > 0 &&
				readedBonos.map( ( bono ) => (
					<Bono key={ bono.codigo } bono={ bono } />
				) ) }
			<div className="sci-bcl-bonos-scanbtns">
				<button onClick={ () => setIsScanning( true ) }>
					<img src={ ScannerIcon } alt="Scanner Icon" />
					<span>Usar Cámara</span>
				</button>
				<form onSubmit={ manualBono }>
					<input
						type="text"
						name="manualCode"
						id="manual-code"
						placeholder="Código"
						ref={ manualCodeRef }
					/>
					<input type="submit" value="›" />
				</form>
				{ error && <p className="sci-bcl-bonos__error">{ error }</p> }
			</div>
			<div className="qr-video-container">
				<video id="qr-video" ref={ videoRef }></video>
			</div>
			{ isScanning && (
				<Scanner
					setIsScanning={ setIsScanning }
					getBonoFromServer={ getBonoFromServer }
					videoRef={ videoRef }
				/>
			) }
			{ isLoading && <Spinner /> }
			<div className="sci-bcl-bonos__total">
				<p>
					Total a pagar:{ ' ' }
					<span>
						{ ( getTotalValue() / 100 )
							.toFixed( 2 )
							.replace( '.', ',' ) }{ ' ' }
						€
					</span>
				</p>
			</div>
		</div>
	);
}
